export default __webpack_public_path__ + "static/media/15-min.fb2cd8a4.png";